import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
  SecurityContext,
} from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { setupFontAwesome } from '@core/config/fontawesome.config';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { JwtInterceptor } from '@core/interceptors/jwt.interceptor';

import { provideLottieOptions } from 'ngx-lottie';
import { provideMarkdown } from 'ngx-markdown';
import { SelectivePreloadStrategy } from '@core/strategies/selective-preload.strategy';

const lottiePlayerFactory = () =>
  import('lottie-web').then((mod: any) => mod.default ?? mod);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(FontAwesomeModule),
    {
      provide: FaIconLibrary,
      useFactory: () => {
        const library = new FaIconLibrary();
        setupFontAwesome(library);
        return library;
      },
    },
    provideLottieOptions({
      player: lottiePlayerFactory,
    }),
    provideMarkdown({
      sanitize: SecurityContext.HTML,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(SelectivePreloadStrategy)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync('noop'),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
  ],
};
